import * as Yup from "yup";

import { RegistrationDataCriteria } from "../types/registrationDataCriteria";
import { ValidationCriterion } from "../types/validationCriterion";

import passwordIncludesUsername from "./passwordIncludesUsername";

export const REGISTRATION_DATA_SCHEMA: RegistrationDataCriteria = {
  EMAIL: {
    FULL: Yup.string()
      .email()
      .matches(/^\S+@\S+\.\S+$/) // Allow expected punctuation including '@'
      .min(5),
  },
};

export const validateUsernameConditions = (
  username: string,
): Array<ValidationCriterion> => {
  return [
    {
      detail: "Start with a letter",
      isValid: Yup.string()
        .matches(/^[a-zA-Z]/)
        .isValidSync(username),
    },
    {
      detail: "Only contain letters or numbers",
      isValid: Yup.string()
        .matches(/^[a-zA-Z0-9]+$/)
        .isValidSync(username),
    },
    {
      detail: "4-80 characters long",
      isValid: Yup.string().min(4).max(80).isValidSync(username),
    },
    {
      detail: "No space",
      isValid: Yup.string().matches(/^\S*$/).isValidSync(username),
    },
  ];
};

export const validatePasswordConditions = (
  password: string,
  username: string,
): Array<ValidationCriterion> => {
  return [
    {
      detail: "1 lowercase letter",
      isValid: Yup.string()
        .matches(/(?=.*[a-z])/)
        .isValidSync(password),
    },
    {
      detail: "1 uppercase letter",
      isValid: Yup.string()
        .matches(/(?=.*[A-Z])/)
        .isValidSync(password),
    },
    {
      detail: "1 number",
      isValid: Yup.string()
        .matches(/(?=.*[0-9])/)
        .isValidSync(password),
    },
    {
      detail: "15+ characters",
      isValid: Yup.string().min(15).isValidSync(password),
    },
    {
      detail: "No parts of your username",
      isValid: !passwordIncludesUsername(password, username),
    },
  ];
};

export const validatePasswordConfirmationConditions = (
  password: string,
  passwordConfirmation: string,
): Array<ValidationCriterion> => {
  return [
    {
      detail: "Password must match",
      isValid: password === passwordConfirmation,
    },
  ];
};

export const validateEmailStringConditions = (
  email: string,
): Array<ValidationCriterion> => {
  return [
    {
      detail: "Valid email address",
      isValid: REGISTRATION_DATA_SCHEMA.EMAIL.FULL.isValidSync(email),
    },
  ];
};
